import {Component, Input, ViewEncapsulation} from '@angular/core';
import {LaColorService} from '../colors/la-color.service';

@Component({
  selector: 'la-icon',
  template: `
    <svg class="la-icon" [style.fill]="bgColor" [ngClass]="{
         'la-icon--x-small':size === 'xsm',
         'la-icon--small': size === 'sm',
         'la-icon--medium': size === 'md',
         'la-icon--large': size === 'large',
         'la-icon--x-large': size === 'xlarge',
         'la-icon--xx-large': size === 'xxlarge',
         'la-icon--card': size === 'card'}">
      <use attr.xlink:href="assets/svg-symbols.svg#{{name}}"></use>
    </svg>
  `,
  styles: [`
    .la-icon{height:32px;width:32px;fill:rgba(3,20,34,.4);vertical-align:middle;overflow:hidden;margin:auto}.la-icon--x-small{height:8px;width:8px}.la-icon--small{height:16px;width:16px}.la-icon--medium{width:24px;height:24px}.la-icon--large{width:32px;height:32px}.la-icon--x-large{width:40px;height:40px}.la-icon--xx-large{width:64px;height:64px}.la-icon--card{width:100px;height:100px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaIconComponent {
  private _name: string;
  private _size = 'large'; // large is default size of icon
  public bgColor: string; // HEX or rgba CSS color
  private _colorName: string; // color name

  constructor(private _laColorService: LaColorService) {
  }

  get name(): string {
    return this._name;
  }

  /**
   * name - to set image path, name is case insensitive.
   */
  @Input()
  set name(name: string) {
    this._name = name.toLowerCase();
  }

  /**
   * size of various size option of icon: sm
   * md is default size
   */
  @Input()
  set size(name: string) {
    this._size = name.toLowerCase();
  }

  get size(): string {
    return this._size;
  }

  get color(): string {
    return this._colorName;
  }

  /**
   * To apply color to icon. support only color palates color.
   */
  @Input()
  set color(colorName: string) {
    this._colorName = colorName.toLowerCase();
    this.bgColor = this._laColorService.getColorByName(colorName);
  }
}
